import { useContext } from 'react';
import styled from 'styled-components';
import Terminal from 'components/Terminal';
import Keyboard from 'components/Keyboard';
import { InterfaceContextProvider } from 'contexts/InterfaceContext';
import { GameContext } from 'contexts/GameContext';
import Footer from 'containers/Footer';
import Box from 'elements/Box';

const InterfaceContainer = styled(Box)(({ theme }) => `
  margin: 0 auto;
  width: 100%;
  max-width: 42rem;
  background: ${theme.colors.utility.ghost};
  color: ${theme.colors.dark};
  border-radius: ${theme.fontSizes.body};
  border-bottom: ${theme.strokes.thick} solid ${theme.colors.utility.secondary};
  overflow: hidden;
`);

const Interface = () => {
  const { handleKeyDown, cursor: { position }} = useContext(GameContext);
  return (
    <Footer collapse={position === undefined}>
      <InterfaceContainer>
        <InterfaceContextProvider handleKeyDown={handleKeyDown}>
          <Terminal />
          <Keyboard />
        </InterfaceContextProvider>
      </InterfaceContainer>
    </Footer>
  );
};

export default Interface;
